import { Button, Dialog, DialogActions, DialogContent } from "@mui/material";
import { useState } from "react";
import { useAuth } from "src/hooks/useAuth";

export const LogoutButton = (props) => {
  const { logout } = useAuth();
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  return (
    <>
      <Button
        size="large"
        fullWidth
        color="secondary"
        disableRipple
        sx={{ mt: 3, justifyContent: "flex-start", py: 2 }}
        onClick={handleOpen}
      >
        خروج
      </Button>

      <Dialog maxWidth="sm" open={open} onClose={handleClose}>
        <DialogContent>
          آیا از خروج از حساب کاربری اطمینان دارید ؟
        </DialogContent>
        <DialogActions sx={{ mt: 5 }}>
          <Button color="secondary" onClick={handleClose}>
            خیر
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={() => {
              logout(true);
            }}
          >
            بله
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
